import { render, staticRenderFns } from "./destination-select-dialog.vue?vue&type=template&id=2be04b0c&"
import script from "./destination-select-dialog.vue?vue&type=script&lang=js&"
export * from "./destination-select-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports